// "可视/非可视" 组件通用 API
import jsBridge from "../../common/jsBridge";

export function destroyComponent({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/destroyComponent', params})
}

export function getComponentOptions({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getComponentOptions', params})
}

/**
 * 关闭广告（销毁所有组件资源）
 * @param unitId 广告位 id
 * @returns {Promise<any>}
 */
export function closeAd({unitId}) {
    let params = {
        unitId,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/closeAd', params})
}